<template>
  <div class="row">
    <div class="col-sm-12"><br>
      <div
        class="container-fluid col-md-12"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
      <router-link :to="{ name: 'menu' }">
				<br><h6>Volver</h6>
            </router-link>
     <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
    </div><br>

    <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<h3 class="text-center"><b>Productos en convenio</b></h3><br>
                </div>
							</div>
							
    </div>

    <div class="d-flex justify-content-center">
      <div class="row">
        <div class="col">
          <select class="form-select" v-model="tipoCarga" @change="cargarProductos()">
            <option value="Productos">Productos</option>
            <option value="Ropa">Ropa</option>
          </select>
        </div>
      </div>
    </div><br>
    
     <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<div>
        <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              
              <th>PRODUCTO</th>
              <th>PRECIO</th>
              <th>STOCK RRHH.</th>
              <th>STOCK TRAN.</th>
              <th>STOCK CAJA.</th>
              <th>ESTADO</th>
              <th>SOLICITUD</th>
              <th>EDITAR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Productos" :key="x.key">
             <!-- <td>{{ x.sku }}</td>-->
              <td>{{ x.descripcion }}</td>
              <td>{{ x.precio }}</td>
              <td>{{ x.stock }}</td>
              <td>{{ x.stockT }}</td>
              <td>{{ x.stockC}}</td>
              <td>{{ x.estado }}</td>
              
              <td v-if="x.estadoSolicitud=='INACTIVO'">
                <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                 
                  @click="activarSolicitudProducto(x.key)"
                >
                 Activar
                </button>
              </td>
              <td v-if="x.estadoSolicitud=='ACTIVO'">
                <button 
                
                  type="button"
                  
                  class="btn btn-danger btn-sm"
                  
                  @click="inactivarSolicitudProducto(x.key)"
                >
                Inactivar
                </button>
              </td>
              

              <td>
                
                <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="editarProducto(x.key,x.sku,x.descripcion,x.precio,x.estado)"
                >
                 <i class="fas fa-edit fa-2x"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table></div>
                </div>
							</div>
							
    </div><br>
							

        <br>
         <div class="d-flex justify-content-center">
         
        <div class="row">
          <div class="col"> 
            <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  @click="agregarProducto()"
                >
                 <i class="fas fa-plus fa-2x"></i>
                </button>
          </div><br><br><br>
        </div>
        
      </div>
       
       <!-- <iframe id="pdf" width="100%" height="800px"></iframe>-->
      </div>
    </div>
    <div>

   <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Agregar Producto</b></h3><br>
           
                <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>DESCRIPCIÓN</label>
                        <input type="text" id="descripcion"  class="form-control" placeholder="Ingrese descripción" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>PRECIO</label>
                        <input type="text" id="precio"  class="form-control" placeholder="Ingrese precio aprox." style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    
                    
                </div><br>
                <div class="row">
                  <div class="col-sm">
                     <label>CONVENIO</label>
                      <select class="form-select" aria-label="Default select example" id="convenioNuevo" style="border-color: rgb(237, 126, 37);">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">ROPA</option>
                      </select>
                  </div>
                </div><br>
                
                
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" rows="3"  style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="agregarProducto2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Agregar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>   

  <b-modal id="modal-2"  hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Editar Producto</b></h3><br>
      <div class="row">
                <input type="text" id="keyEditar" v-model="keyEditar" class="form-control" placeholder="Ingrese SKU" style="display:none"   readonly>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>ACTUAL</label>
                        <input type="text" id="skuEditar" v-model="skuEditar" class="form-control" placeholder="Ingrese SKU" style="border-color:rgb(237,126,37)"   readonly>
                         </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>DESCRIPCIÓN</label>
                        <input type="text" id="descripcionEditar"  v-model="descripcionEditar"  class="form-control" placeholder="Ingrese descripción" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div><br>
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>PRECIO</label>
                        <input type="text" id="precioEditar"   v-model="precioEditar" class="form-control" placeholder="Ingrese precio aprox." style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                      <label>ESTADO</label>
                      <select class="form-select" aria-label="Default select example" id="estadoEditar" style="border-color: rgb(237, 126, 37);">
                      <option value="ACTIVO">ACTIVO</option>
                      <option value="INACTIVO">INACTIVO</option>
                      </select>
                    </div>
                   
                </div><br>
                
                
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="editarProducto2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>
</div>
  </div>
  
</template>

<script>
import { db } from "../firebaseDb";
import Swal from "sweetalert2";
import Vue from 'vue'
 var sd = require('silly-datetime');
    import { BootstrapVue } from 'bootstrap-vue'
    Vue.use(BootstrapVue)

export default {
  data() {
    return {
      Productos: [],
      producto:{},
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      sku:'',
      descripcion:'',
      precio:'',
      stock:'',
      FoliosSap:[],
      FoliosAsignar:[],
      totalFoliosAsignar:0,
      resumenFoliosAsignar:'',
      montoTransferencia:0,
      diferenciaMontos:0,
      idDocumentoFb:'',
      foliosAntiguos:'',
      rutBuscarFolios:'',
      fecha2BF:'',
      fecha1BF:'',
      tipoMonto:'',
      skuEditar:'',
      descripcionEditar:'',
      precioEditar:'',
      keyEditar:'',
      tipoCarga:'Productos',
    };
  },
  created() {
   
            this.usuario=localStorage.nombreUsuario;
            //console.log(this.usuario)
            this.cargarProductos();
            this.validarUsuario();  
   
    
  },
  methods: {
    activarSolicitudProducto(key){
      //console.log(key)
      if(confirm("Desea activar el producto para que lo soliciten?")){
        db.collection('productos').doc(key)
                .update({solicitud:"ACTIVO"}).then(() => {
                    //console.log("User successfully updated!");
                    //this.$router.push('/list')
                }).catch((error) => {
                    console.log(error);
                }); 
      }
       
    },
    inactivarSolicitudProducto(key){
     // console.log(key)
      if(confirm("Desea desactivar el producto para que no lo soliciten?")){
        db.collection('productos').doc(key)
                .update({solicitud:"INACTIVO"}).then(() => {
                    //console.log("User successfully updated!");
                    //this.$router.push('/list')
                }).catch((error) => {
                    console.log(error);
                }); 
      }
    },

     cargarProductos(){
        //var tipo=document.getElementById("tipoCarga").value;
        console.log(this.tipoCarga)
          if(this.tipoCarga=="Productos"){
            db.collection('productos').where("convenio","!=",3).orderBy("convenio","asc").orderBy("sku","asc").onSnapshot((snapshotChange) => {
                this.Productos = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron productos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                      if(doc.data().sku!="-Seleccione-"){
                          this.Productos.push({
                          key: doc.id,
                          sku: doc.data().sku,
                          descripcion: doc.data().descripcion,
                          precio: doc.data().precio,
                          stock: doc.data().stock,
                          stockT: doc.data().stockT,  
                          stockC: doc.data().stockC, 
                          estado: doc.data().estado, 
                          estadoSolicitud: doc.data().solicitud, 
                      })
                    }
                  });
                }
          })
          }else{
            db.collection('productos').where("convenio","==",3).orderBy("sku","asc").onSnapshot((snapshotChange) => {
                this.Productos = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron productos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                      if(doc.data().sku!="-Seleccione-"){
                          this.Productos.push({
                          key: doc.id,
                          sku: doc.data().sku,
                          descripcion: doc.data().descripcion,
                          precio: doc.data().precio,
                          stock: doc.data().stock,
                          stockT: doc.data().stockT,  
                          stockC: doc.data().stockC, 
                          estado: doc.data().estado, 
                          estadoSolicitud: doc.data().solicitud, 
                      })
                    }
                  });
                }
          })
          }
         
    },
    agregarProducto(){
         this.$bvModal.show("modal-1")
    },
    agregarProducto2() {
     // var sku=document.getElementById("sku").value.toUpperCase() 
      var descripcion= document.getElementById("descripcion").value.toUpperCase() 
      var precio = document.getElementById("precio").value
      if(descripcion!="" && precio!=""){
        var docRef = db.collection("productos").where("descripcion", "==", descripcion);

        docRef.get().then((doc) => {
            var largo=(doc.docs.length)

            if (largo>0) {
                Swal.fire({
                        title: "Error",
                        text: "Ya existe este SKU",
                        icon: "error",
                    })
            } else {
                this.Productos = [];
                    this.producto.sku = document.getElementById("descripcion").value.toUpperCase() 
                    this.producto.descripcion = document.getElementById("descripcion").value.toUpperCase() 
                    this.producto.precio = document.getElementById("precio").value
                    this.producto.stock = "0"
                    this.producto.stockT = "0"//document.getElementById("stock").value
                    this.producto.stockC = "0"
                    this.producto.observacion = document.getElementById("observacion").value.toUpperCase() 
                    this.producto.estado = "ACTIVO"
                    this.producto.solicitud = "INACTIVO"
                    this.producto.convenio=parseInt(document.getElementById("convenioNuevo").value)
                    db.collection('productos').add(this.producto).then(() => {
                        Swal.fire({
                        title: "Listo",
                        text: "Producto Registrado",
                        icon: "success",
                    })
                    //document.getElementById("sku").value=""
                    document.getElementById("descripcion").value=""
                    document.getElementById("precio").value=""
                   // document.getElementById("stock").value=""
                    document.getElementById("observacion").value=""
                    //this.imagenCorreo(correo,id,usuario,vendedor,rutFacturacion,cuenta,nombre,monto,fechaTransaccion);
                    this.$bvModal.hide("modal-1")
                    }).catch((error) => {
                        console.log(error);
                    });
            }   
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

      }else{
        Swal.fire({
                        title: "Error",
                        text: "Debe completar los campos",
                        icon: "error",
                    })
      }
     

    
    
    
    },




    editarProducto(key,sku,descripcion,precio,estado){
     // console.log(key,sku,descripcion,precio)
       this.$bvModal.show("modal-2")
       //document.getElementById("keyEditar").value=key
       this.skuEditar=sku
       this.descripcionEditar=descripcion
       this.precioEditar=precio
       this.keyEditar=key

       this.skuEditarAntiguo=sku
       this.descripcionEditarAntiguo=descripcion
       this.precioEditarAntiguo=precio
       this.estadoEditarAntiguo=estado
    },

    editarProducto2(){
      var estado=document.getElementById("estadoEditar").value;
      if(this.descripcionEditar!="" && this.precioEditar!="" && estado!=""){
        db.collection('productos').doc(this.keyEditar)
                        .update({sku:  this.descripcionEditar,descripcion:this.descripcionEditar,precio:this.precioEditar,estado:estado}).then(() => {
                            Swal.fire({
                                title: "Listo",
                                text: "Producto Actualizado",
                                icon: "success",
                            })
                            this.registrarHistorico()
                            this.$bvModal.hide("modal-2")
                            document.getElementById("skuEditar").value=""
                            document.getElementById("descripcionEditar").value=""
                            document.getElementById("precioEditar").value=""
                            document.getElementById("keyEditar").value=""
                        }).catch((error) => {
                            console.log(error);
                        });
      }else{
          Swal.fire({
                        title: "Error",
                        text: "Debe completar los campos",
                        icon: "error",
                    })
      }
                        
    },
    registrarHistorico(){
      this.obtenerFecha()
      var fecha=this.fecha;
      var hora=this.hora;
      var fr=this.año+this.mes+this.dia
      
      var x=new Object
                  x.skuAntiguo=this.skuEditarAntiguo  
                  x.descripcionAntiguo=this.descripcionEditarAntiguo
                  x.precioAntiguo=this.precioEditarAntiguo 
                  x.estadoAntiguo=this.estadoEditarAntiguo 

                  x.skuNuevo=this.skuEditar  
                  x.descripcionNuevo=this.descripcionEditar
                  x.precioNuevo=this.precioEditar 
                  x.estadoNuevo=document.getElementById("estadoEditar").value

                  x.fecha=fecha 
                  x.hora=hora
                  x.fr=fr

                  x.usuario=this.usuario

                 db.collection('historicosku').add(x).then(() => {
                        console.log("movimiento registrado")
                        //this.actualizarStock2(sku,cantidad)
                    }).catch((error) => {
                        console.log(error);
                    });
    },

    
     validarUsuario(){
             //document.getElementById("monto").display = "none";   
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },

      leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        },
      asignarFolio(key,rut,monto,folio,tipo){
        this.tipoMonto=tipo
        this.montoTransferencia=monto;
        this.idDocumentoFb=key;
        this.FoliosSap=[];
        this.foliosAntiguos=folio
        this.rutBuscarFolios=rut;
        console.log(key,rut,monto,tipo)
        this.$bvModal.show("modal-2");
       /* console.log("espere ")
                this.$bvModal.show("modal-2");
                fetch("https://silent-water-26924.pktriot.net/12/"+rut)
							.then(response => {
									return response.json()
								})

							.then(data =>this.tablaSap(data.recordset));
              //.then(data=>console.log(data))*/
      },
      buscarfoliosfecha(){
        this.FoliosSap=[];
        if(this.fecha1BF!="" && this.fecha2BF!=""){
          var rut=this.rutBuscarFolios
          var fecha=this.fecha1BF+"|"+this.fecha2BF
          console.log(rut+"|"+fecha)
          console.log("espere ")
                  this.$bvModal.show("modal-2");
                  fetch("https://silent-water-26924.pktriot.net/12/"+rut+"|"+fecha)
                .then(response => {
                    return response.json()
                  })

                .then(data =>this.tablaSap(data.recordset));
                //.then(data=>console.log(data))
        }else{
          alert("Debe ingresar un rango de fechas")
        }
        
      },
      


      tablaSap(data){
        console.log(data.length)
        if(data.length>0){
          let y=this
          console.log(data)
          data.forEach(function(dato){
                /*<td>{{ x.FolioNum }}</td>
                <td>{{ x.TipoDoc }}</td>
                <td>{{ x.LicTradNum }}</td>
                <td>{{ x.CardName }}</td>
                <td>{{ x.Fecha }}</td>
                <td>{{ x.Bruto }}</td>*/
            //x.FoliosSap.push(dato);
            var x=new Object()
            x.FolioNum=dato.FolioNum;
            x.TipoDoc=dato.TipoDoc;
            x.LicTradNum=dato.LicTradNum;
            x.CardName=dato.CardName;
            var fecha=dato.Fecha.split('T')
            x.Fecha=fecha[0];
            x.Bruto=dato.Bruto;
            y.FoliosSap.push(x);


          })

        }else{
          alert("No se encontraron documentos")
        }
        
      },

      agregarFolio(folio,monto){
        console.log(this.tipoMonto)
        if(this.tipoMonto=='Parcial'){
          console.log(monto)
          //console.log(this.montoTransferencia-this.totalFoliosAsignar)
          //var dif1=this.montoTransferencia-this.totalFoliosAsignar;
            var doc1 = new Object();
            doc1.folio=folio
            doc1.monto=monto
            this.FoliosAsignar.push(doc1)
            this.totalFoliosAsignar=this.totalFoliosAsignar+monto;
            this.resumenFoliosAsignar=this.resumenFoliosAsignar+folio+" ";
            this.diferenciaMontos=this.montoTransferencia-this.totalFoliosAsignar;
          
        }else{
          console.log(monto)
          console.log(this.montoTransferencia-this.totalFoliosAsignar)
          var dif=this.montoTransferencia-this.totalFoliosAsignar;
          if(monto<=dif){
            var doc = new Object();
            doc.folio=folio
            doc.monto=monto
            this.FoliosAsignar.push(doc)
            this.totalFoliosAsignar=this.totalFoliosAsignar+monto;
            this.resumenFoliosAsignar=this.resumenFoliosAsignar+folio+" ";
            this.diferenciaMontos=this.montoTransferencia-this.totalFoliosAsignar;
          }else{
            alert("El monto del folio excede el monto restante de la transferencia")
          }
        }
        
        
        
      },
      quitarFolio(folio,monto){
        let x=this
        var data=this.FoliosAsignar;
        this.FoliosAsignar=[]
        data.forEach(function(dato){
          if(dato.folio==folio){
            console.log("no")
             x.diferenciaMontos=x.diferenciaMontos+monto;
             x.totalFoliosAsignar=x.totalFoliosAsignar-monto;
          }else{
            x.FoliosAsignar.push(dato)
          }
        })
        //this.totalFoliosAsignar=this.totalFoliosAsignar-monto;
        this.resumenFoliosAsignar=this.resumenFoliosAsignar.replaceAll(folio,"");

      },
       obtenerFecha(){
            this.fecha=sd.format(new Date(), 'DD-MM-YYYY');
            this.dia=(sd.format(new Date(), 'DD'))
            this.mes=(sd.format(new Date(), 'MM'))
            this.año=(sd.format(new Date(), 'YYYY'))
            this.hora=sd.format(new Date(), 'HH:mm');
        },
      guardarFolios(){
        var doc=this.idDocumentoFb;
        var folios=this.foliosAntiguos+" "+this.resumenFoliosAsignar
        console.log(doc,folios)
        //db.collection('transacciones').doc(doc).update()
        db.collection("transacciones").doc(doc).update(
          {
            folio: folios,
            diferencia:this.diferenciaMontos
          }
        )
        this.$bvModal.hide("modal-2");
      },

      
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>